import { Autocomplete, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaOptionsDropdown from "~/modules/app/components/GaiaOptionsDropdown";

type Props = {
    researchTypes: { id: string; name: string }[];
    plannerAreas: { id: string; name: string }[];
    selectedResearchTypeIdFilter: string | null;
    onChangeResearchTypeId: (values: string) => void;
    selectedPlannerAreaIdsFilter: string[];
    onChangePlannerAreaIds: (values: string[]) => void;
};

export function ProjectDeliverablesFilters({
    researchTypes,
    plannerAreas,
    selectedResearchTypeIdFilter,
    onChangeResearchTypeId,
    selectedPlannerAreaIdsFilter,
    onChangePlannerAreaIds,
}: Props) {
    const { t } = useTranslation("project");

    const researchTypeOptions = researchTypes.map(x => ({ label: x.name, value: x.id }));
    const plannerAreaOptions = plannerAreas.map(x => ({ label: x.name, value: x.id }));

    return (
        <Stack direction="row" spacing={2}>
            <GaiaOptionsDropdown
                label={t("deliverablesScreen.labelResearchType")}
                options={researchTypeOptions}
                value={selectedResearchTypeIdFilter}
                onChange={e => {
                    onChangeResearchTypeId(e.target.value);
                }}
                sx={{ minWidth: 250 }}
            />
            <Autocomplete
                multiple
                disableCloseOnSelect
                options={plannerAreaOptions}
                value={plannerAreaOptions.filter(x => selectedPlannerAreaIdsFilter.includes(x.value))}
                onChange={(_, nextValue) => {
                    onChangePlannerAreaIds(nextValue.map(v => v.value));
                }}
                renderInput={params => <TextField {...params} label={t("deliverablesScreen.labelPlannerAreas")} />}
                sx={{ minWidth: 350 }}
            />
        </Stack>
    );
}
